/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
const style: { [key: string]: React.CSSProperties } = {
  'pre[class*="language-"]': {
    color: '#d4d4d4',
    fontSize: 'var(--typography-code-font-size)',
    fontWeight: 'var(--typography-code-font-weight)',
    letterSpacing: '0',
    lineHeight: '1.25rem',
    textShadow: 'none',
    fontFamily: 'var(--typography-code-font-family), monospace',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
    padding: '1em',
    margin: '.5em 0',
    overflow: 'auto',
    background: '#1e1e1e',
  },
  'code[class*="language-"]': {
    color: '#d4d4d4',
    fontSize: 'var(--typography-code-font-size)',
    fontWeight: 'var(--typography-code-font-weight)',
    letterSpacing: '0',
    lineHeight: '1.25rem',
    textShadow: 'none',
    fontFamily: 'var(--typography-code-font-family), monospace',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
  },
  '.namespace': {
    opacity: '.7',
  },
  comment: {
    color: 'var(--code-light-comment)',
  },
  prolog: {
    color: 'var(--code-light-comment)',
  },
  punctuation: {
    color: 'var(--code-light-operator)',
  },
  property: {
    color: 'var(--code-light-property)',
  },
  boolean: {
    color: 'var(--code-light-boolean-literal)',
  },
  number: {
    color: 'var(--code-light-number-literal)',
  },
  string: {
    color: 'var(--code-light-string-literal)',
  },
  char: {
    color: 'var(--code-light-string-literal)',
  },
  operator: {
    color: 'var(--code-light-operator)',
  },
  keyword: {
    color: 'var(--code-light-keyword)',
  },
  'keyword.module': {
    color: 'var(--code-light-keyword)',
  },
  'keyword.control-flow': {
    color: 'var(--code-light-keyword)',
  },
  function: {
    color: 'var(--code-light-function)',
  },
  'function.maybe-class-name': {
    color: 'var(--code-light-function)',
  },
  regex: {
    color: 'var(--code-light-operator)',
  },
  italic: {
    fontStyle: 'italic',
  },
  variable: {
    color: 'var(--code-light-property)',
  },
};

export default style;
